import actions from '../utils/restActions';


const events = (state = {}, action) => {
    
    switch (action.type) {

    case actions.events.index.status.success:
	return Object.assign({}, state, {list:  action.data});
    case actions.events.show.status.request:
	return Object.assign({}, state, {current:  null});
    case actions.events.show.status.success:
	return Object.assign({}, state, {current:  action.data});
    default:
	return state;
    }
}

export default events;



// WEBPACK FOOTER //
// ./src/reducers/Events.js